<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-04-28 13:10:58
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\BlockLeave\BlockLeavePolicy\newBlockLeavePolicy.vue
 * @最后编辑: Please set LastEditors
 * @最后修改时间: 2022-05-05 10:55:56
-->
<template>
  <ContentLayout
    widthClass="max-1000"
    :title="$t('label_essweb_BlockLeavePolicy_form_newTitle')"
    pad="0"
    :initData="BlockLeaveGroupData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'block_leave_group_name',
      'block_leave_group_code',
      'include_holiday',
      'start_month',
      'min_days',
      'include_day_off',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper :curStep="curStep" :items="stepper">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row align="center" justify="start" class="white lighten-5">
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  maxlength="100"
                  :bindData="BlockLeaveGroupData.block_leave_group_name"
                  @change="
                    (valueArr) => {
                      BlockLeaveGroupData.block_leave_group_name = valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_BlockLeavePolicy_list_BlockLeaveGroupNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :label="
                    $t(
                      'label_essweb_BlockLeavePolicy_form_BlockLeaveGroupCodeLabel'
                    )
                  "
                  maxlength="100"
                  v-model="BlockLeaveGroupData.block_leave_group_code"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <numberInputTextFiled
                  :disabled="page_params.start_month !== null"
                  :rules="
                    $GetRules(['_Number_negative', '_Length_Rules'], [null, 99])
                  "
                  v-model="BlockLeaveGroupData.start_month"
                  :label="
                    $t(
                      'label_essweb_BlockLeavePolicy_form_BlockLeaveStartMonthLabel'
                    )
                  "
                  :max="12"
                  :min="1"
                  isNotRequire
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <numberInputTextFiled
                  :disabled="page_params.min_days !== null"
                  :rules="
                    $GetRules(['_Number_negative', '_Length_Rules'], [null, 99])
                  "
                  v-model="BlockLeaveGroupData.min_days"
                  :label="
                    $t(
                      'label_essweb_BlockLeavePolicy_form_BlockLeaveMinDaysLabel'
                    )
                  "
                  isNotRequire
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <BooleanRadioField
                  v-model="BlockLeaveGroupData.include_holiday"
                  isRequire
                  :label="
                    $t('label_essweb_BlockLeavePolicy_form_includeHolidayLabel')
                  "
                  @click="
                    (boolean) => {
                      BlockLeaveGroupData.include_holiday = boolean;
                    }
                  "
              /></v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <BooleanRadioField
                  v-model="BlockLeaveGroupData.include_day_off"
                  isRequire
                  :label="
                    $t('label_essweb_BlockLeavePolicy_form_includeDayOffLabel')
                  "
                  @click="
                    (boolean) => {
                      BlockLeaveGroupData.include_day_off = boolean;
                    }
                  "
              /></v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-btn
            text
            small
            class="text-capitalize"
            color="primary"
            @click="newLeveType()"
          >
            {{ $t("label_essweb_leaveType_list_title") }}
            <span class="material-icons-round">add</span>
          </v-btn>
          <noContent v-if="LeaveType.length <= 0" />
          <v-container fluid class="ma-0 pa-0 px-3">
            <v-form ref="form2" lazy-validation>
              <v-sheet
                class="d-flex align-center my-3"
                v-for="(item, index) in LeaveType"
                :key="`leavetype--${index}`"
              >
                <AutoComplete
                  class="flex-grow-1"
                  isRequired
                  two-line
                  :items="LeaveTypeList"
                  item-text="leave_type_name"
                  label="label_essweb_leaveType_list_title"
                  item-value="uuid"
                  :rules="$GetRules(['_Require_ArrRules'], [null])"
                  v-model="item.leave_type_uuid"
                >
                  <template v-slot:selection="{ data }">
                    {{ $getCommonLangValue(data.item.leave_type_name) }}
                    <span class="text--secondary text-caption"
                      >({{
                        $getCommonLangValue(data.item.leave_type_abbr)
                      }})</span
                    >
                  </template>
                  <template v-slot:item.title="{ data }">
                    {{ $getCommonLangValue(data.item.leave_type_name) }}
                  </template>
                  <template v-slot:item.subtitle="{ data }">
                    {{ $getCommonLangValue(data.item.leave_type_abbr) }}
                  </template>
                </AutoComplete>
                <v-btn
                  icon
                  class="text-capitalize ml-1"
                  color="secondary"
                  @click="deleteLeveType(item.key)"
                >
                  <span class="material-icons-round">delete</span>
                </v-btn>
              </v-sheet>
            </v-form>
          </v-container>
        </template>
      </Stepper></template
    >
    <!-- content -->
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :newBtn="step == curStep && curStep != 0 ? true : false"
        :step="step == curStep ? false : true"
        @next="toNext"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @new="toAdd"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main> </template>
    <!-- tools end -->
  </ContentLayout>
</template>
<script>
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  name: "newBlockLeaveGroup",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      step: 2,
      stepper: [
        "label_essweb_BlockLeavePolicy_form_step_generalLabel",
        "label_essweb_BlockLeavePolicy_form_step_LeaveTypeMappingLabel",
      ],
      isChanged: false,
      curStep: 1,
      LeaveTypeList: [],
      LeaveType: [],
      BlockLeaveGroupData: {
        block_leave_group_name: "",
        block_leave_group_code: "",
        include_holiday: 0,
        include_day_off: 0,
        start_month: 1,
        min_days: 0,
        remarks: "",
      },
      page_params: null,
    };
  },
  created() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.args));
    this.BlockLeaveGroupData.start_month = this.page_params.start_month
      ? this.page_params.start_month
      : 1;
    this.BlockLeaveGroupData.min_days = this.page_params.min_days
      ? this.page_params.min_days
      : 0;
    this.getLeaveType();
  },
  methods: {
    getLeaveType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/get-list/",
      }).then((res) => {
        that.LeaveTypeList = res.data;
      });
    },
    toAdd() {
      const that = this;
      if (!this.$refs["form"].validate() || !this.$refs["form2"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_lv_block_leave_group",
        url: "/block-leave-group/add/",
        data: {
          block_leave_group_code:
            this.BlockLeaveGroupData.block_leave_group_code,
          block_leave_group_name: this.$transCommonLangKey(
            this.BlockLeaveGroupData.block_leave_group_name
          ),
          include_holiday: Number(this.BlockLeaveGroupData.include_holiday)
            ? 1
            : 0,
          include_day_off: Number(this.BlockLeaveGroupData.include_day_off)
            ? 1
            : 0,
          start_month: this.BlockLeaveGroupData.start_month,
          min_days: this.BlockLeaveGroupData.min_days,
          remarks: this.BlockLeaveGroupData.remarks,
          ess_lv_block_leave_group_map_leave_type: this.LeaveType.map(
            (item) => {
              return {
                leave_type_uuid: item.leave_type_uuid,
              };
            }
          ),
        },
      }).then((res) => {
        that.$toBack();
      });
    },
    toNext() {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.curStep = this.curStep + 1;
    },
    newLeveType() {
      this.LeaveType.push({
        key: Math.random() * 999999999 + "" + new Date().valueOf(),
        leave_type_uuid: "",
      });
    },
    deleteLeveType(key) {
      this.LeaveType = this.LeaveType.filter((ele) => ele.key !== key);
    },
  },
};
</script>